import { render, staticRenderFns } from "./BaseTableDataRow.vue?vue&type=template&id=22b5bdd9&"
import script from "./BaseTableDataRow.vue?vue&type=script&lang=js&"
export * from "./BaseTableDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports